import React from "react";
import MirsTable from "components/general/table/Table";
import {speedQualificationHeatsColumns } from "./Columns";
import { isSpeedSeeding, isSpeedQualification, isSemis } from "components/sports/clb/helper/ClbHelpers";
import { isLiveStatus, isStartListStatus, isFinishedStatus } from "helpers/status";
import LoaderSubComponent from "components/general/LoaderSubComponent";
import Label from "components/general/Label";
import CaptionTable from "components/general/table/CaptionTable";
import Status from "components/presentation/Status";

const Heats = ({data, extraData, extraData2, mirs_competition, mirs_language, mirs_rsc, breakPoint}) => {

    extraData?.sort((a ,b) => a?.heat - b?.heat);
    let resultStatus = '';
    let scheduleStatus = '';
    const live = extraData && extraData?.find(ed => (ed?.resultStatus !== 'START_LIST' && !ed?.resultStatus.includes('OFFICAL')));
    const isStartList = extraData && extraData?.filter(ed => (ed?.resultStatus === 'START_LIST'))?.length === extraData.length;
    const isFinished = extraData && extraData?.filter(ed => (ed?.resultStatus.includes('OFFICAL')))?.length === extraData.length;
    if(live){
      resultStatus = live.resultStatus;
      scheduleStatus = live?.scheduleStatus;
    } else if (isFinished){
      resultStatus = extraData[0].resultStatus;
      scheduleStatus = extraData[0]?.scheduleStatus;
    } else if (isFinished){
      resultStatus = extraData[extraData.length-1].resultStatus;
      scheduleStatus = extraData[extraData.length-1]?.scheduleStatus;
    }

    const isMobile = breakPoint === "sm" || breakPoint === "xs" 

    const caption = (<CaptionTable
      rightCol={<Status typeToPrint="result" scheduleStatus={scheduleStatus} resultStatus={resultStatus} />} />)
    
    const getColumns = () => {
      return speedQualificationHeatsColumns();    
    }

    const getInitialSortBy = () => {
      return [{ id: 'Heat', desc: false }];
    }

    const getHiddenColumns = () => {
      return [];
    }

    const getCurrentIndicator = (row) => {
      return  {className: row.original?.resultStatus === 'LIVE' ? 'currentIndicator' : ''}  
    }

    const getCellQualified = (cellInfo) => {
      let out = ''
      if(isSpeedQualification(mirs_rsc)){
        let isQual = cellInfo.row.original?.qualificationMark
        if (isQual && (cellInfo?.column?.id === 'NOC' || cellInfo?.column?.id === 'Name')) {
          out = {className: (cellInfo?.column?.className || '') + ' fw-bold' }

        } else if (cellInfo?.column?.id === 'NOC' || cellInfo?.column?.id === 'Name') {
          out = {className: (cellInfo?.column?.className || '')?.replaceAll(' fw-bold', '')}
        }
      }
      return out  
    }

    //console.log(data)
    return <>
            <MirsTable
                id={`mirs-table-result-${mirs_rsc}`}
                sortable={!isMobile}
                data={data}
                columns={getColumns()}
                keyRow={"code"}
                caption={caption}
                initialSortBy={getInitialSortBy()}
                hiddenColumns={getHiddenColumns()}
                getRowProps={row => { return getCurrentIndicator(row) }}
                getCellProps={cellInfo => {return getCellQualified(cellInfo) }}
            />

    </>
}

export default Heats;

